import React from 'react';

const OpenShiftConsultancy = () => (
  <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
          OpenShift Consultancy
        </h1>
        <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
          <p className="text-lg text-gray-700 mb-6">
            Our OpenShift Consultancy service helps organizations design, implement, and optimize their OpenShift environments for maximum efficiency and scalability. We provide expert guidance on cluster architecture, CI/CD integration, security best practices, and cost optimization.
          </p>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li>OpenShift cluster setup and upgrades</li>
            <li>Application migration and modernization</li>
            <li>Security hardening and compliance</li>
            <li>Custom automation and GitOps workflows</li>
          </ul>
          <p className="text-gray-700">
            Contact us to discuss how we can accelerate your OpenShift journey.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default OpenShiftConsultancy;
